import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OurScooters.module.css';

const scooters = [
  { id: 5, name: 'Honda Scoopy', price: '220', descKey: 's1Desc', image: 'honda-scoopy.png' },
  { id: 1, name: 'Honda Click 125', price: '260', descKey: 's2Desc', image: 'honda-click-125.png' },
  { id: 2, name: 'Honda Click 160', price: '290', descKey: 's3Desc', image: 'honda-click-160.png' },
  { id: 3, name: 'Honda PCX 160', price: '350', descKey: 's4Desc', image: 'honda-pcx.png' },
  { id: 4, name: 'Honda ADV 160', price: '420', descKey: 's5Desc', image: 'honda-avd-160.png' },
  { id: 6, name: 'Honda ADV 350', price: '850', descKey: 's6Desc', image: 'honda-adv-350.png' },
];

function OurScooters() {
  const { t } = useTranslation();
  const baseUrl = process.env.PUBLIC_URL || '';

  const imgSrc = (filename) => (baseUrl ? `${baseUrl}/${filename}` : `/${filename}`);

  return (
    <section id="scooters" className={styles.section}>
      <h2 className={styles.heading}>{t('ourScooters.heading')}</h2>
      <p className={styles.subheading}>
        {t('ourScooters.subheading')}
      </p>
      <p className={styles.note}>
        <span className={styles['note-icon']}>💡</span>
        {t('ourScooters.note')}
      </p>
      <div className={styles.grid}>
        {scooters.map((scooter) => (
          <article key={scooter.id} className={styles.card}>
            <div className={styles['card-image']}>
              <img
                src={imgSrc(scooter.image)}
                alt={`${scooter.name} - Scooter rental Phuket`}
                loading="lazy"
              />
            </div>
            <h3 className={styles['card-title']}>{scooter.name}</h3>
            <p className={styles.price}>
              <span className={styles['price-label']}>{t('ourScooters.from')}</span>{' '}
              <span className={styles['price-value']}>{scooter.price}</span>{' '}
              <span className={styles['price-unit']}>{t('ourScooters.thbPerDay')}</span>
            </p>
            <p className={styles.description}>{t(`ourScooters.${scooter.descKey}`)}</p>
            <a href="#pricing" className={styles.link}>
              {t('ourScooters.viewPrices')}
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}

export default OurScooters;
